import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";
import AuthAPI from "../../Api/authApi";

export const resetPassword = createAsyncThunk(
  "reset/resetPassword",
  async ({token, newPassword,confirmPassword}, thunkAPI) => {
    try {
      const response = await AuthAPI.resetPassword(token, newPassword,confirmPassword);
      const message=(response.message)
      thunkAPI.dispatch(setMessage(message))
      return response;
    } catch (error) {

      // console.log("Error Object:",error.response.message);
      const message=error.response?.data?.message || error.message || "Something went wrong";
      thunkAPI.dispatch(setMessage(message))

      return thunkAPI.rejectWithValue(message);
    }
  }
); 

const initialState = {
  data: null, 
  loading: false,  
  error: null, 
};

const resetPasswordSlice = createSlice({
  name: "reset",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.data = action.payload; 
        state.loading = false;
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;

      });
  },
});

const { reducer } = resetPasswordSlice;
export default reducer;
